module.exports = __webpack_public_path__ + "img/service04.7ac224de.jpg";